/** This slice is to capture upload information */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	uploadCount: 0,
	totalImageUploadCount: 0,
	uploadInProgress: false,
	totalImagesUploaded: 0,
	totalImagesFailed: 0,
	unsupportedFiles: [],
	showInvalidFilesModal: false,
	currentUploadDetails: {
		totalCount: 0,
		failedCount: 0,
	},
	failedImages: [],
};

export const uploadSlice = createSlice({
	name: 'upload',
	initialState: initialState,
	reducers: {
		incrementUploadCount: (state, action) => {
			state.uploadCount = state.uploadCount + 1;
		},
		setTotalImageUploadCount: (state, action) => {
			state.totalImageUploadCount = action.payload;
		},
		setUploadCount: (state, action) => {
			state.uploadCount = action.payload;
		},
		setUploadInProgress: (state, action) => {
			state.uploadInProgress = action.payload;
		},
		setTotalImagesUploaded: (state, action) => {
			state.totalImagesUploaded =
				state.totalImagesUploaded + action.payload;
		},
		setTotalImagesFailed: (state, action) => {
			state.totalImagesFailed = state.totalImagesFailed + action.payload;
		},
		decrementTotalImagesUploaded: (state, action) => {
			state.totalImagesUploaded = state.totalImagesUploaded - 1;
		},
		setUnsupportedFiles: (state, action) => {
			state.unsupportedFiles = action.payload;
		},
		setShowInvalidFilesModal: (state, action) => {
			state.showInvalidFilesModal = action.payload;
		},
		setCurrentUploadDetails: (state, action) => {
			state.currentUploadDetails = action.payload;
		},
		setFailedImages: (state, action) => {
			state.failedImages = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const {
	incrementUploadCount,
	setTotalImageUploadCount,
	setUploadCount,
	setUploadInProgress,
	setTotalImagesUploaded,
	decrementTotalImagesUploaded,
	setTotalImagesFailed,
	setShowInvalidFilesModal,
	setUnsupportedFiles,
	setCurrentUploadDetails,
	setFailedImages,
} = uploadSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectUploadCount = (state) => state.upload.uploadCount;
export const selectTotalImageUploadCount = (state) =>
	state.upload.totalImageUploadCount;
export const selectUploadInProgress = (state) => state.upload.uploadInProgress;
export const selectTotalImagesUploaded = (state) =>
	state.upload.totalImagesUploaded;
export const selectTotalImagesFailed = (state) =>
	state.upload.totalImagesFailed;
export const selectUnsupportedFiles = (state) => state.upload.unsupportedFiles;
export const selectShowInvalidFilesModal = (state) =>
	state.upload.showInvalidFilesModal;
export const selectCurrentUploadDetails = (state) =>
	state.upload.currentUploadDetails;
export const selectFailedImages = (state) => state.upload.failedImages;

export default uploadSlice.reducer;
